import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { getApiUrl } from '../../../utils/apiConfig';


const SegmentoDropdown = ({ selectedVisita, setSelectedVisita }) => {
  const [segmentoOptions, setSegmentoOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const fetchSegmentos = async () => {
      try {
        const res = await fetch(getApiUrl('/api/segmento'));
        const data = await res.json();
        const opciones = data.map(item => {
          const value = item.IdSegmento.trim();
          return {
            value,
            label: item.Segmento.trim(),
            color: '#eee',
            id: value
          };
        });
        setSegmentoOptions(opciones);
      } catch (error) {
        console.error('Error al obtener los segmentos:', error);
      }
    };
    fetchSegmentos();
  }, []);

  const selected = {
    value: selectedVisita?.IdSegmento || '',
    label: selectedVisita?.Segmento || '',
    color: '#eee'
  };

  const placeholder = 'Selecciona segmento';
  const hasSelection = Boolean((selectedVisita?.IdSegmento || '').trim());

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);


  return (
    <div className="relative w-full" ref={containerRef}>
      <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Segmento*</label>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="DropDownName w-full p-2 shadow-sm border rounded bg-white flex justify-between items-center"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        title={hasSelection ? selected.label : placeholder}
      >
        <span className={`truncate ${hasSelection ? '' : 'text-gray-400'}`}>
          {hasSelection ? selected.label : placeholder}
        </span>
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <ul className="absolute mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto"  style={{ zIndex: 1100 }} role="listbox">
          <li
            onClick={() => { setSelectedVisita({ ...selectedVisita, IdSegmento: '', Segmento: '' }); setIsOpen(false); }}
            className={`cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors ${!hasSelection ? 'bg-blue-50 text-blue-700 font-medium' : ''}`}
            role="option"
            aria-selected={!hasSelection}
          >
            {placeholder}
          </li>
          {segmentoOptions.map(option => (
            <li
              key={option.value}
              onClick={() => {
                setSelectedVisita({ ...selectedVisita, IdSegmento: option.value, Segmento: option.label });
                setIsOpen(false);
              }}
              className={classNames(
                'cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors',
                { 'bg-blue-50 text-blue-700 font-medium': (selectedVisita.IdSegmento?.trim() || '') === option.value }
              )}
              role="option"
              aria-selected={(selectedVisita.IdSegmento?.trim() || '') === option.value}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SegmentoDropdown;
